<template>
  <div class="ab-wrapper">
    <bs-structure
      :box-margin-r="60"
      :box-margin-l="60"
      :box-right-w="324"
    >
      <!-- header -->
      <template slot="boxHeader">
        <bs-header
          :is-show-login="false"
          :data="data"
        >
          <!-- 传data -->
        </bs-header>
      </template>
      <!-- body -->
      <template slot="boxBody">
        <bs-preLogin />
      </template>
    </bs-structure>
  </div>
</template>
<script>
import bsHeader from 'components/business/link/header/index.vue'
import bsStructure from 'components/business/structure/index.vue'
import bsPreLogin from 'components/business/preLogin/index.vue'

export default {
  name: 'BsInvalid',
  components: {
    bsStructure,
    bsPreLogin,
    bsHeader,
  },
  props: {
    data: {
      type: Object,
      default() {
        return {
        }
      },
    },
  },
  data() {
    return {

    }
  },
  created() {
    this.data = this.$route.query.body
  },
  methods: {
  },
}
</script>
<style lang="less" scoped>
  @import '~less/button.less';
  .ab-wrapper{
    width: 100%;
    height: 100%;
  }
</style>
